// components/Common/Forms/RHFAutocomplete.jsx
import { Autocomplete, TextField, InputAdornment } from "@mui/material";
import { Controller } from "react-hook-form";
import PropTypes from "prop-types";

const RHFAutocomplete = ({
  name,
  control,
  label,
  placeholder,
  required = false,
  options = [],
  multiple = false,
  getOptionLabel = (option) => option?.label || "",
  isOptionEqualToValue = (option, value) => option?.value === value?.value,
  disabled = false,
  startAdornment,
  endAdornment,
  ...props
}) => (
  <Controller
    name={name}
    control={control}
    render={({ field: { onChange, value, ref }, fieldState: { error } }) => (
      <Autocomplete
        multiple={multiple}
        options={options}
        getOptionLabel={getOptionLabel}
        isOptionEqualToValue={isOptionEqualToValue}
        value={value || (multiple ? [] : null)}
        onChange={(_, newValue) => onChange(newValue)}
        disabled={disabled}
        renderInput={(params) => (
          <TextField
            {...params}
            inputRef={ref}
            label={label}
            placeholder={placeholder}
            required={required}
            error={!!error}
            helperText={error?.message}
            InputProps={{
              ...params.InputProps,
              startAdornment: startAdornment ? (
                <InputAdornment position="start">
                  {startAdornment}
                </InputAdornment>
              ) : (
                params.InputProps.startAdornment
              ),
              endAdornment: endAdornment ? (
                <InputAdornment position="end">{endAdornment}</InputAdornment>
              ) : (
                params.InputProps.endAdornment
              ),
            }}
          />
        )}
        {...props}
      />
    )}
  />
);

export default RHFAutocomplete;

RHFAutocomplete.propTypes = {
  name: PropTypes.string.isRequired,
  control: PropTypes.object.isRequired,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  options: PropTypes.array,
  multiple: PropTypes.bool,
  getOptionLabel: PropTypes.func,
  isOptionEqualToValue: PropTypes.func,
  disabled: PropTypes.bool,
  startAdornment: PropTypes.node,
  endAdornment: PropTypes.node,
};
